import { yayApi } from '../baseApi'
import {
  pathApiChatRoomsReport,
  pathApiGroupsReport,
  pathApiPostsReport,
  pathApiUsersReport,
} from 'lib/paths'

export const reportApi = yayApi
  .enhanceEndpoints({
    addTagTypes: [],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      createUserReport: build.mutation({
        query: (data) => ({
          url: pathApiUsersReport({ userId: data?.userId }),
          method: 'POST',
          data,
        }),
      }),

      createChatRoomReport: build.mutation({
        query: (data) => ({
          url: pathApiChatRoomsReport({ chatRoomId: data?.chatRoomId }),
          method: 'POST',
          data,
        }),
      }),

      createPostReport: build.mutation({
        query: (data) => ({
          url: pathApiPostsReport({ postId: data?.postId }),
          method: 'POST',
          data,
        }),
      }),

      createGroupReport: build.mutation({
        query: (data) => ({
          url: pathApiGroupsReport({ groupId: data?.groupId }),
          method: 'POST',
          data,
        }),
      }),
    }),
    overrideExisting: false,
  })

export const {
  endpoints,
  useCreateUserReportMutation,
  useCreateChatRoomReportMutation,
  useCreatePostReportMutation,
  useCreateGroupReportMutation,
} = reportApi
